import { render, staticRenderFns } from "./ResultTotals.vue?vue&type=template&id=a205b5b4"
import script from "./ResultTotals.vue?vue&type=script&lang=ts"
export * from "./ResultTotals.vue?vue&type=script&lang=ts"
import style0 from "./ResultTotals.vue?vue&type=style&index=0&id=a205b5b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports